<template>
  <div>
    <div class="footer">
      <div class="f-btn" @click="showPayPop()">{{ btnName }}</div>
      <!-- <img class="f-img" @click="showPay = true" src="../../assets/images/member_new/button_pay.png"/> -->
      <agreement></agreement>
      <!-- <div class="f-text">点击开通即为同意<span>《会员服务协议》  《自动续费协议》</span></div> -->
    </div>
    <van-popup
      v-model="showPay"
      round
      position="bottom"
      closeable
      :close-icon="imgX"
    >
      <div class="pop-pay">
        <div class="pop-title">{{ item.productDesc[3] }}</div>
        <div class="pop-divider"></div>
        <!-- <div class="pop-doc">{{item.productDesc[2]}}</div> -->
        <div class="pop-wechat">
          <img class="pop-icon" :src="selectPayIcon" />
          <span class="pop-we-text">{{ getPayName() }}</span>
          <img
            class="pop-icon-right"
            @click="selectedWeChat = !selectedWeChat"
            :src="payIcon"
          />
        </div>
        <div
          v-if="awardList.length > 0"
          class="pop-discount"
          @click="showDiscountPop()"
        >
          <img
            class="pop-icon"
            src="../../assets/images/member_new/ic_award.png"
          />
          <span class="pop-discount-text">优惠券</span>
          <span class="pop-discount-right-text">{{
            selectedDiscount
          }}</span>
        </div>
        <div class="footer-sec">
          <div class="f-btn" @click="goPay()">{{ btnName }}</div>
          <agreement></agreement>
          <!-- <div class="f-text">点击开通即为同意<span>《会员服务协议》  《自动续费协议》</span></div> -->
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showDiscount"
      round
      position="center"
      style="width:90%"
      closeable
      :close-icon="imgX"
    >
      <div class="pop-discount-content">
        <div class="pop-title">助学金券</div>
        <div class="pop-discount-list">
          <div v-for="(item, idx) of awardList" :key="idx">
            <div role="separator" class="divider" v-if="idx != 0"></div>
            <div class="item-no" :class="{ 'item-not-use': item.notUse }">
              <img
              class="pop-icon-right"
              @click="checkedOne(item)"
              :disabled="item.notUse"
              :src="checkBg(item)"
              />
              <div class="text-title">
                {{
                  discountInfo.filter((n) => n.awardId == item.awardId)[0]
                    .title
                }}
              </div>
              <div class="text-desc">
                {{
                  discountInfo.filter((n) => n.awardId == item.awardId)[0].desc
                }}
              </div>

              <div class="price-content">
                <span class="price">{{
                  discountInfo.filter((n) => n.awardId == item.awardId)[0]
                    .price
                }}</span>
                <span class="price-icon">元</span>
              </div>
              <div class="text-date">
                {{item.notUse ? "不符合使用条件" : "有效期至：2021.09.30 23:59"}}
              </div>
            </div>
          </div>
        </div>
        <div class="footer-award">
          <div class="f-btn" @click="confirmAward()">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import Agreement from "./member_agreement_new";
import { isIOS, isAndroid } from "@/utils/env";
const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
const categoryId = utils.getQueryString("categoryId");
const pageChannelId = utils.getQueryString("pageChannelId");
const productId = utils.getQueryString("productId"); //商品Id
const pageChannel = utils.getQueryString("pageChannel");
export default {
  components: {
    Agreement,
  },
  props: {
    Info: {
      type: Object,
    },
    source: {
      // and；ios
      type: String,
    },
    title: {
      type: String,
    },
    btnText: {
      type: String,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      imgX: require("../../assets/images/member_new/btn_X.png"),
      payIcon0: require("../../assets/images/member_new/btn_we_0.png"),
      payIcon1: require("../../assets/images/member_new/btn_we_1.png"),
      selectPayIconWechat: require("../../assets/images/member_new/wechat.png"),
      selectPayIconApple: require("../../assets/images/member_new/apple.png"),
      awardSelectNotUseIcon:require("../../assets/images/member_new/ic_checkbox_disable.png"),
      awardSelectIcon:require("../../assets/images/member_new/ic_checkbox_select.png"),
      awardUnSelectIcon:require("../../assets/images/member_new/ic_checkbox_unselect.png"),

      showPay: false,
      selectedWeChat: true,
      showDiscount: false,
      selectedDiscount: "请选择优惠券",
      btnName: "立即购买",
      radio: -1,
      recordIds:[],
      awardList:[],
      productItem:this.item,
      usefulAwardList: [
        {
          awardId: 7,
          title: "45元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超308元使用",
          price: "45",
          date: "有效期至2021年01月01日",
          notUse: false,
        },
        {
          awardId: 8,
          title: "10元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超78元使用",
          price: "10",
          date: "有效期至2021年01月01日",
          notUse: true,
        },
        {
          awardId: 9,
          title: "5元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超35元使用",
          price: "5",
          date: "有效期至2021年01月01日",
          notUse: false,
        },
      ],
      discountInfo: [
        {
          awardId: 7,
          title: "45元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超308元使用",
          price: "45",
          date: "有效期至2021年01月01日",
          notUse: false,
        },
        {
          awardId: 8,
          title: "10元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超78元使用",
          price: "10",
          date: "有效期至2021年01月01日",
          notUse: true,
        },
        {
          awardId: 9,
          title: "5元助学金券",
          desc: "仅限于购买小盒课堂APP连续包月会员且实付金额超35元使用",
          price: "5",
          date: "有效期至2021年01月01日",
          notUse: false,
        },
      ],
    };
  },
  computed(){
    
  },
  created() {
    
  },
  mounted() {
    this.getInfoData();
    // this.setDiscountContent();
    // this.setDefaultAward();
   
  },

  methods: {
    async getInfoData() {
      let resp = await ajax.get(
        "/pay/return-money/homepage-new?timestamp=" + Date.now(),
        {
          params: { token, version, source },
        }
      );
      if (resp.config) resp = resp.data;
      if (resp.code == 99999) {
        this.infoData = resp.data;
      } else {
        this.$toast(resp.msg);
      }
    },
    checkedOne (selectAward) {
        if(selectAward.notUse) return;
        let recordId = selectAward.recordId;
        let idIndex = this.recordIds.indexOf(recordId)
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.recordIds.splice(idIndex, 1)
          this.productItem = this.Info.memberProductList.find(n => n.awardId == -selectAward.awardId);

        } else {
           // 选中该checkbox
           this.recordIds.splice(0,this.recordIds.length)
           this.recordIds.push(recordId)
            this.productItem= this.Info.memberProductList.find(n => n.awardId == selectAward.awardId);
        }
    },
    confirmAward(){
      this.showDiscount = false
      if(this.productItem.awardId > 0){
        this.btnName = this.productItem.productDesc[5] ? this.productItem.productDesc[5] : "券后" + this.productItem.discountPrice + "元   立即开通";
      }else{
        this.btnName = this.productItem.productDesc[5] ? this.productItem.productDesc[5] : this.productItem.discountPrice + "元   立即开通" 
        let selectAwardId = -this.productItem.awardId;
        let result = this.Info.awardList.filter((n) => n.awardId == selectAwardId || n.awardId == -selectAwardId);
        this.selectedDiscount = result.length + "张助学金券可用";
      }
    },
    showDiscountPop(){
      if(this.Info.awardList.length == 0) return;
      let selectAwardId = -this.item.awardId;
      let result = this.Info.awardList.filter((n) => n.awardId == selectAwardId || n.awardId == -selectAwardId);
      this.recordIds.push(result[0].recordId);

      this.productItem = this.item;
      this.setDefaultAward();
      this.showDiscount = true;

    },
    showPayPop(){
      this.setDefaultAward()
      this.awardList = this.getUsefullAwardList();
      // this.showPay = true
      this.productItem = this.item;
      this.goPay()
    },
    setButtonName(currentItem){
      if(currentItem.awardId > 0){
        this.btnName = currentItem.productDesc[5] ? currentItem.productDesc[5] : "券后" + currentItem.discountPrice + "元   立即开通" 
      }else{
        this.btnName = currentItem.productDesc[5] ? currentItem.productDesc[5] : currentItem.discountPrice + "元   立即开通" 
      }
    },
    setDefaultAward(){
      if(this.Info.awardList.length == 0) return;
      let selectAwardId = -this.item.awardId;
      let result = this.Info.awardList.filter((n) => n.awardId == selectAwardId || n.awardId == -selectAwardId);
      if(result == null || result.length == 0){
        this.btnName = this.item.productDesc[5] ? this.item.productDesc[5] : this.item.discountPrice + "元   立即开通" 
        return
      }
      this.selectedDiscount = this.discountInfo.find(n => n.awardId == result[0].awardId).title;

      if(this.item.awardId > 0){
        this.btnName = this.item.productDesc[5] ? this.item.productDesc[5] : "券后" + this.item.discountPrice + "元   立即开通" 
      }else{
        this.btnName = this.item.productDesc[5] ? this.item.productDesc[5] : this.item.discountPrice + "元   立即开通" 
      }

    },
    getUsefullAwardList () {
      if(this.Info.awardList.length == 0 || this.item.awardId <= 0) return [];

      let selectAwardId = -this.item.awardId;
      let result = this.Info.awardList.filter((n) => n.awardId == selectAwardId || n.awardId == -selectAwardId);
      
      let noUseList = this.Info.awardList.filter((n) => n.awardId != selectAwardId && n.awardId != -selectAwardId);
      //识别有效优惠券
      result.map((item) => {
        item.notUse = false;
      })
      noUseList.map((item) => {
        item.notUse = true;
      })
      
      return result.concat(noUseList);
      
    },
    getChecked(item) {
      console.log("selectedDiscountId===", item.recordId);

    },
    getPayName() {
      if (isAndroid()) {
        return "微信";
      } else {
        return "应用内购买";
      }
    },
    setDiscountContent() {
      this.selectedDiscount =
        this.getUsefullAwardList().length == 1
          ? this.discountInfo.find(
              (n) => n.awardId == this.getUsefullAwardList()[0].awardId
            ).title
          : this.getUsefullAwardList().length + "张助学金券可用";
    },
    useDiscount(item) {
      if (item.notUse) return;
      this.selectedDiscount = this.discountInfo.find(
        (n) => n.awardId == item.awardId
      ).title;
      this.showDiscount = false;
      console.log("radio===",radio)
      this.$parent.setDiscountPackageInfo(item.awardId,radio);
    },
    goActivity() {
      this.$router.push({
        path:
          "/member/member_card?version=" +
          version +
          "&token=" +
          token +
          "&source=" +
          source,
      });
    },
    isActivity() {
      return (
        this.infoData.isPaid != 1 &&
        ((this.productType == 26 && isAndroid()) ||
          (this.item.productType == 29 && isIOS()))
      );
    },
    goPay(from) {
      if(!this.selectedWeChat){
        this.$toast("未选中支付方式");
        return;
      }
      if (from !== "cancelPop") {
        gio("track", "vipOpenPgae_open_click", this.getGioParams());
        utils.sendLog(
          {
            token,
            version,
            source,
            extensionJson: this.getGioParams(),   
          },
          "hzxx911"
        );
      }
      let comeFrom = this.Info.needUpgrade ? "113" : "112";
      
      if (this.source === "ios" && this.isSameMemberProduct(this.Info)) {
        this.showPay = false;
        return;
      }
      let url = "";
      // if(isIOS() && this.item.productTypeId == 3187 ||  isAndroid() && this.item.productTypeId == 3183) {
      //     this.$router.push({path: '/member/member_card?version=' + version + '&token=' + token + '&source=' + source});
      //     return;
      // }
      if (this.isActivity()) window.goAddress = true;
      else window.goAddress = false;
      console.log("productPure===",this.productItem.isPureSign)
      if (pageChannel) {
        url =
          this.source === "ios"
            ? `hybird://method/openDirectPay?productId=${this.productItem.productId}&jsCallBack=jsCallback&pageChannel=${pageChannel}`
            : `hybird://method/${
                this.productItem.isPureSign == 1 ? "openFreeDirectPay" : "openDirectPay"
              }?productId=${
                this.productItem.productId
              }&jsCallBack=jsCallback&productName=${
                this.productItem.title
              }&comeFrom=${comeFrom}&paymentChannel=wx&pageChannel=${pageChannel}`;
      } else {
        url =
          this.source === "ios"
            ? `hybird://method/openDirectPay?productId=${this.productItem.productId}&jsCallBack=failToast`
            : `hybird://method/${
                this.productItem.isPureSign == 1 ? "openFreeDirectPay" : "openDirectPay"
              }?productId=${
                this.productItem.productId
              }&jsCallBack=jsCallback&productName=${
                this.productItem.title
              }&comeFrom=${comeFrom}&paymentChannel=wx`;
      }
      setTimeout(() => {
        window.location.href = url;
        this.showPay = false;
      }, 100);
    },
    getGioParams() {
      return {
        categoryId,
        pageChannelId,
        isVip: this.Info.isMember,
        productId,
      };
    },
    // 相同套餐emit事件；
    isSameMemberProduct(Info) {
      let hasSameMember = false;
      Info.memberProductList.map((item) => {
        if (item.productId == Info.iosProductId) {
          hasSameMember = true;
          this.$emit("toggleMemberProductPopup");
        }
      });
      if(hasSameMember){
        return true;
      }else{
        return false;
      }
    },
  },
  computed: {
    payIcon: function () {
      let str = this.selectedWeChat ? this.payIcon1 : this.payIcon0;
      return str;
    },
    selectPayIcon: function () {
      let str = isAndroid()
        ? this.selectPayIconWechat
        : this.selectPayIconApple;
      return str;
    },
    checkBg() {
      return function(item) {
        let str = this.recordIds.indexOf(item.recordId)>=0 ? this.awardSelectIcon : this.awardSelectNotUseIcon;
        if(item.notUse){
          str = this.awardSelectNotUseIcon;
        }
        return str;
        }
      },

  },
};
</script>
<style lang="scss" scoped>
.f-btn {
  height: 0.96rem;
  background: #ff6e45 linear-gradient(90deg, #ffdab1 0%, #fcb170 100%);
  border-radius: 52rem;
  margin: 0.16rem 0.4rem 0.12rem 0.4rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #7a3104;
  line-height: 0.96rem;
  position: relative;
  &::after{
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 1.54rem;
    height: 0.96rem;
    animation: move 2.5s infinite ease-in-out;
    background: url('../../assets/images/member_new/move-light.png') no-repeat;
    background-size: 100% 100%;
  }
}
@keyframes move {
    0% {
      left: -20%;
    }
    100% {
      left: 100%;
    }
  }
.footer-sec {
  width: 100%;
  height: 2.14rem;
  background-color: #ffffff;
  padding-top: 0.4rem;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.f-img {
  width: 6.7rem;
  height: 0.96rem;
  margin: 0.16rem 0.4rem 0.12rem 0.4rem;
}
.f-text {
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8597a6;
  line-height: 0.34rem;
  & > span {
    color: #9d5e43ff;
  }
}
.footer {
  position: fixed;
  width: 100%;
  height: 1.74rem;
  background-color: #ffffff;
  // bottom: constant(safe-area-inset-bottom);
  // bottom: env(safe-area-inset-bottom);
  bottom: 0;
  text-align: center;
}
.pop-pay {
  text-align: center;
  .pop-divider{
    height: 0.01rem;
    background: #F5F8FC;
    line-height: 0.01rem;
    margin: 0.01rem 0.4rem 0.01rem 0.4rem;

  }
  .pop-title {
    height: 1.12rem;
    font-size: 0.34rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3a4961;
    line-height: 1.12rem;
    box-shadow: 0rem 2rem 0rem 0rem rgba(245, 248, 252, 1);
  }
  .pop-doc {
    padding: 0.36rem 0.4rem 0.48rem 0.4rem;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8597a6;
    line-height: 0.42rem;
    text-align: left;
    background-color: #ffffff;
  }
  .pop-wechat {
    display: flex;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    padding-top: 0.24rem;
    height: 1.24rem;
    border-radius: 0.2rem;
    background-color: #ffffff;
    align-items: center;
    .pop-icon {
      width: 0.48rem;
      height: 0.48rem;
      margin-right: 0.2rem;
    }
    .pop-icon-right {
      width: 0.48rem;
      height: 0.48rem;
      margin-left: auto;
    }
    .pop-we-text {
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3a4961;
      line-height: 0.3rem;
    }
  }
  .pop-discount {
    display: flex;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    padding-top: 0.16rem;
    height: 1.16rem;
    border-radius: 0.2rem;
    background-color: #ffffff;
    align-items: center;
    .pop-icon {
      width: 0.48rem;
      height: 0.48rem;
      margin-right: 0.2rem;
    }
    .pop-icon-right {
      width: 0.48rem;
      height: 0.48rem;
      margin-left: auto;
    }
    .pop-discount-text {
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3a4961;
      line-height: 0.3rem;
    }
    .pop-discount-right-text {
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 300;
      color: #FF8B1F;
      line-height: 0.3rem;
      position: relative;
      margin-left: auto;
      margin-right: 0.45rem;
      &:after {
        content: "";
        position: absolute;
        width: 0.44rem;
        height: 0.44rem;
        background: url("../../assets/images/member_new/right_arrow.png") 0 0 /
          cover no-repeat;
        margin-top: -0.08rem;
      }
    }
  }
}
.pop-discount-content {
  height: 9.68rem;
     text-align: center;
  .pop-title {
    height: 1.12rem;
    font-size: 0.4rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A4961;
    line-height: 1.12rem;
    box-shadow: 0rem 2rem 0rem 0rem rgba(245, 248, 252, 1);
  }
  .footer-award{
     width: 100%;
     text-align: center;
     padding-left: 0.5rem;
     padding-right: 00.5rem;
    .f-btn {
      height: 0.88rem;
      background: #ff6e45 linear-gradient(90deg, #ffdab1 0%, #fcb170 100%);
      position: relative;
      top:0.2rem;
      border-radius: 44rem;
      font-size: 0.36rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7a3104;
      line-height: 0.88rem;
    }
  }
  
  .pop-discount-list {
    height: 7.06rem;
    padding-top: 0.06rem;
    padding-bottom: 0.48rem;
    padding-left: 0.24rem;
    padding-right: 0.24rem;
    // display: flex;
    // display: -webkit-box;
    text-align: left;
    overflow: scroll;
    .pop-icon-right{
      width: 0.48rem;
      height: 0.48rem;
      position: absolute;
      bottom: 0.2rem;
      right: 0.32rem;
    }
    .text-title {
      position: absolute;
      top: 0.24rem;
      margin-left: 1.9rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7A3104;
      line-height: 0.42rem;
    }
    .text-desc {
      position: absolute;
      top: 0.78rem;
      margin-left: 1.9rem;
      font-size: 0.22rem;
      width:3.46rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #7A3104;
      line-height: 0.3rem;
    }

    .price-content {
      position: absolute;
      left: 0.5rem;
      top: 0.5rem;
    }
    .price {
      font-size: 0.72rem;
      font-family: BebasNeue;
      color: #ff8b1f;
      line-height: 0.64rem;
      position: relative;
    }
    .price-icon {
      width: 0.3rem;
      height: 0.64rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff8b1f;
      line-height: 0.56rem;
      position: relative;
    }
    
    .text-date {
      position: absolute;
      left: 0.3rem;
      bottom: 0.3rem;
      color:#7A3104;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    .second {
      font-size: 0.24rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fcb170;
      line-height: 0.34rem;
      text-decoration: line-through;
    }
    .item-nom {
      font-size: 0.22rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a2b1bf;
      line-height: 0.22rem;
      position: absolute;
      width: 2.1rem;
      bottom: 0.18rem;
    }
    .item-no {
      position: relative;
      width: 100%;
      height: 2.5rem;
      background: #FFE9D3;
      border-radius: 0.3rem;
      //   text-align: center;
      margin-right: 0.2rem;
    }
    .divider {
      height: 0.2rem;
    }
    .item-not-use {
      position: relative;
      width: 100%;
      height: 2.5rem;
      // text-align: center;
      margin-right: 0.2rem;

      background: #FFFFFF;
      box-shadow: 0px 0px 100px 0px rgba(187, 187, 187, 0.05);
      border-radius: 0.3rem;
      border: 0.02rem solid #E6EAED;  

      .tip-bg {
        position: absolute;
        top: 0;
        right: 0rem;
        width: 2.08rem;
        height: 0.56rem;
        background: #ff8b1f;
        border-radius: 0 0 0.3rem 0.28rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.34rem;
        padding-top: 0.1rem;
      }
      .text-title {
      position: absolute;
      top: 0.24rem;
      margin-left: 1.9rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #A2B1BF;
      line-height: 0.42rem;
    }
    .text-desc {
      position: absolute;
      top: 0.78rem;
      margin-left: 1.9rem;
      font-size: 0.22rem;
      color: #A2B1BF;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 0.3rem;
    }

    .price {
      font-size: 0.72rem;
      font-family: BebasNeue;
      color: #A2B1BF;
      line-height: 0.64rem;
      position: relative;
    }
    .price-icon {
      width: 0.3rem;
      height: 0.64rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #A2B1BF;
      line-height: 0.56rem;
      position: relative;
    }
    .text-date {
      position: absolute;
      left: 0.3rem;
      bottom: 0.3rem;
      color:#FF8B1F;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    }
  }
}
</style>
